import { render, staticRenderFns } from "./LgFinderPageModelo.vue?vue&type=template&id=76e8835c"
import script from "./LgFinderPageModelo.vue?vue&type=script&lang=js"
export * from "./LgFinderPageModelo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports